
const NycSvg = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 128 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M104 49L64.0004 40L24 49L64.0004 58L104 49Z" stroke="#0085FF" />
      <path d="M64 58L77 128" stroke="#0085FF" />
      <path d="M64 58L50 128" stroke="#0085FF" />
      <path d="M103 49L96 128" stroke="#0085FF" />
      <path d="M103.5 49L104 128" stroke="#0085FF" />
      <path d="M24.5 49L31 128" stroke="#0085FF" />
      <path d="M24 48.5L21 128" stroke="#0085FF" />
      <path
        d="M37 48.001C37 42.9158 37.0002 40.0647 37 34.9795C36.9998 28.0343 90 28.034 90 34.9795V48.001C90 55.8135 37 54.0773 37 48.001Z"
        fill="var(--background-tertiary)"
        stroke="#0085FF"
      />
      <path d="M37 34.9834C37 43.0927 90 43.0927 90 34.9834" stroke="#0085FF" />
      <path d="M63 36V2" stroke="#0085FF" />
    </svg>
  );
};

export default NycSvg;
